import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import Menu from './@component/Menu/Menu';
import Personal from './Personal/Personal';
import Employment from './Employment/Employment';
import Payroll from './Payroll/Payroll';

const DetailEmployee = () => {

    const { id } = useParams();
    
    const [employee, setEmployee] = useState([]);
    const [employment, setEmployment] = useState([]);
    const [payroll, setPayroll] = useState([]);
    const [bank, setBank] = useState([]);
    const [error, setError] = useState(null);

    const [menuSelected, setMenuSelected] = useState("personal");

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_EMPLOYEE = "/api/hrppsu/employee/employee/detail";
    const PATH_EMPLOYMENT = "/api/hrppsu/employee/employment";
    const PATH_PAYROLL = "/api/hrppsu/employee/payroll";
    

    const fetchData = async (URL) => {
        try {
            const response = await axios.get(URL);
            return response.data; // Return only the data from the response
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
            console.log(err);
        }
    };

    useEffect(() => {
        const hash = window.location.hash.replace("#", ""); // Remove the '#' symbol
        if (!hash) {
            updateHash("personal");
        }
        setMenuSelected(hash);        
    }, []);

    useEffect(() => {
        onLoad();
    }, [id, menuSelected]);

    const onLoad = () => {
        if (menuSelected == 'personal') {
            fetchData(`${BASE_URL}${PATH_EMPLOYEE}?id=${id}`,).then((data) => {
                setEmployee(data);
            });            
        } else if(menuSelected == 'employment') {
            fetchData(`${BASE_URL}${PATH_EMPLOYMENT}?id_employee=${id}`,).then((data) => {
                setEmployment(data);
            });
        } else if(menuSelected == 'payroll') {
            fetchData(`${BASE_URL}${PATH_PAYROLL}?id_employee=${id}`,).then((data) => {
                setPayroll(data);
            });
            fetchData(`${BASE_URL}${PATH_PAYROLL}/bank?id_employee=${id}`,).then((data) => {
                setBank(data);
            });
        } 
    }

    const updateHash = (newHash) => {
        window.location.hash = newHash;
    };

    return (
        <div className='flex gap-5'>
            <Menu
                menuSelected={menuSelected}
                employee={employee}
                onChange={(value) => {
                    setMenuSelected(value);
                    updateHash(value);
                }} />

            {menuSelected == 'personal' ? <Personal employee={employee.as_array} /> : <></>}
            {menuSelected == 'employment' ? <Employment id_employee={employee.id} employment={employment} onRefresh={() => onLoad()} /> : <></>}
            {menuSelected == 'education_experience' ? <p>No Data Found</p> : <></> }
            {menuSelected == 'additional_info' ? <p>No Data Found</p> : <></> }
            {menuSelected == 'payroll' ? <Payroll id_employee={employee.id} payroll={payroll} bank={bank} onRefresh={() => onLoad()}/> : <></> }
            
        </div>
    )
}

export default DetailEmployee;
